// import React, { useEffect, useState } from 'react';
// import PageContainer from 'src/components/container/PageContainer';
// import { useMain } from '../hooks/useMain';
// import Overview from './Overview';
// import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// import TableViewFormate from './TableViewFormate';

// const currentMonth = () => {
//   const newDate = new Date();
//   const day = newDate.getDate();
//   const month = newDate.getMonth() + 1; // Months are zero-indexed, so add 1
//   const year = newDate.getFullYear();
//   const formattedDate = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`;
//   return { month: month < 10 ? `0${month}` : month, year };
// };

// const currentDate = () => {
//   const newDate = new Date();
//   const day = newDate.getDate();
//   const month = newDate.getMonth() + 1; // Months are zero-indexed, so add 1
//   const year = newDate.getFullYear();
//   const formattedDate = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`;
//   return { month: month < 10 ? `0${month}` : month, year };
// };

// const Attendance = () => {
//   const [month, setMonth] = useState(currentMonth().month);
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [year, setYear] = useState(currentDate().year);
//   const [overviewData, setOverviewData] = useState({
//     monthlyAttendance: 0,
//     todayAppointments: 0,
//     totalSalary: 0,
//     totalIncentive: 0,
//   });

//   const { fetchAttendanceByStaffId, activeStaffId, branchId, fetchOverview } = useMain();

//   const getAttendance = async (id) => {
//     getOverviewData(activeStaffId, branchId);
//     const queryParams = `?branchId=${branchId}&month=${year}-${month}`;
//     try {
//       setLoading(true);
//       const res = await fetchAttendanceByStaffId(id, queryParams);
//       if (res.statusCode === 200) {
//         setData(res?.data.attendanceData || []);
//       }
//     } catch (error) {
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getOverviewData = async (activeStaffId, branchId) => {
//     const queryParams = `?branchId=${branchId}&month=${year}-${month}`;
//     try {
//       const res = await fetchOverview(activeStaffId, queryParams);
//       if (res.statusCode === 200) {
//         setOverviewData(pre => ({ ...pre, ...res.data }));
//       } else {
//         setOverviewData(pre => ({
//           ...pre,
//           ...{
//             monthlyAttendance: 0,
//             todayAppointments: 0,
//             totalSalary: 0,
//             totalIncentive: 0,
//           },
//         }));
//       }
//     } catch (error) {
//       setOverviewData(pre => ({
//         ...pre,
//         ...{
//           monthlyAttendance: 0,
//           todayAppointments: 0,
//           totalSalery: 0,
//           totalIncentive: 0,
//         },
//       }));
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (activeStaffId && branchId) {
//       getAttendance(activeStaffId);
//       getOverviewData(activeStaffId, branchId);
//     }
//   }, [activeStaffId, branchId]);

//   return (
//     <PageContainer title="Dashboard" description="this is Dashboard">
//       <Overview overviewData={overviewData} />
//       {loading ? (
//         <ShowLoader />
//       ) : (
//         <TableViewFormate
//           data={data}
//           getAttendance={getAttendance}
//         />
//       )}
//     </PageContainer>
//   );
// };

// export default Attendance;

import React, { useEffect, useState } from 'react';
import PageContainer from 'src/components/container/PageContainer';
import { useMain } from '../hooks/useMain';
import Overview from './Overview';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import TableViewFormate from './TableViewFormate';

const currentMonth = () => {
  const newDate = new Date();
  const month = newDate.getMonth() + 1; // Months are zero-indexed, so add 1
  const year = newDate.getFullYear();
  return { month: month < 10 ? `0${month}` : month, year };
};

const currentDate = () => {
  const newDate = new Date();
  const month = newDate.getMonth() + 1; // Months are zero-indexed, so add 1
  const year = newDate.getFullYear();
  return { month: month < 10 ? `0${month}` : month, year };
};

const Attendance = () => {
  const [month, setMonth] = useState(currentMonth().month);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [year, setYear] = useState(currentDate().year);
  const [overviewData, setOverviewData] = useState({
    monthlyAttendance: 0,
    todayAppointments: 0,
    totalSalary: 0,
    totalIncentive: 0,
  });

  const { fetchAttendanceByStaffId, activeStaffId, branchId, fetchOverview } = useMain();

  const getAttendance = async (id) => {
    getOverviewData(activeStaffId, branchId);
    const queryParams = `?branchId=${branchId}&month=${year}-${month}`;
    try {
      setLoading(true);
      const res = await fetchAttendanceByStaffId(id, queryParams);
      if (res.statusCode === 200) {
        setData(res?.data.attendanceData || []);
      }
    } catch (error) {
      // Handle error
    } finally {
      setLoading(false);
    }
  };

  const getOverviewData = async (activeStaffId, branchId) => {
    const queryParams = `?branchId=${branchId}&month=${year}-${month}`;
    try {
      const res = await fetchOverview(activeStaffId, queryParams);
      if (res.statusCode === 200) {
        setOverviewData(pre => ({ ...pre, ...res.data }));
      } else {
        setOverviewData(pre => ({
          ...pre,
          monthlyAttendance: 0,
          todayAppointments: 0,
          totalSalary: 0,
          totalIncentive: 0,
        }));
      }
    } catch (error) {
      setOverviewData(pre => ({
        ...pre,
        monthlyAttendance: 0,
        todayAppointments: 0,
        totalSalary: 0,
        totalIncentive: 0,
      }));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (activeStaffId && branchId) {
      getAttendance(activeStaffId);
      getOverviewData(activeStaffId, branchId);
    }
  }, [activeStaffId, branchId]);

  return (
    <PageContainer title="Dashboard" description="this is Dashboard">
      <Overview overviewData={overviewData} />
      {loading ? (
        <ShowLoader />
      ) : (
        <TableViewFormate
          data={data}
          getAttendance={getAttendance}
        />
      )}
    </PageContainer>
  );
};

export default Attendance;
